import { joinPathsStringUtil } from 'utils/string/index.js'

export function getByQueryPathSuffixReduxUtil (query) {
  if (!query) {
    return ''
  }

  return joinPathsStringUtil(
    'byQuery',
    query.replace(/\./gi, '_').toLowerCase()
  )
}
